import * as React from 'react';
import '../css/current-info-card.sass';
import Card from './Card';
import Anchor from './Anchor';

interface CurrentInfoCardProps {
  title: string;
  subTitle?: string;
  content: React.ReactNode;
  disclaimerText?: React.ReactNode;
  link?: string;
  linkLabel?: string;
  theme?: 'night' | 'day';
}

export default function CurrentInfoCard(props: CurrentInfoCardProps) {
  const { theme = 'night' } = props;

  return (
    <div className={`current-info-card ${theme}`}>
      <Card theme={theme}>
        <h2 className="title">{props.title}</h2>
        <div className="subTitle">{props.subTitle}</div>
        <div className="content">{props.content}</div>
        <div className="notes">{props.disclaimerText}</div>
        {props.link && props.linkLabel && (
          <div className="link">
            <Anchor
              arialabel="currentInfoCard"
              id="currentInfoCardId"
              href={props.link}
              theme={theme}
              forward
            >
              {props.linkLabel}
            </Anchor>
          </div>
        )}
      </Card>
    </div>
  );
}
